import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AppRouter from 'routing/route.main';
import fetchCurrentUserAction from 'actions/admin-user/action.user-get-current';
import fetchUserListAction from 'actions/admin-user/action.user-list';
import fetchTranslations from 'actions/admin-translation/action.translations';
import { getTranslations } from 'store/admin-translation/reducer.translations';
import { useGetTranslationsQuery  } from 'actions/translation-api';

const App = () => {
  useGetTranslationsQuery();

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchCurrentUserAction()); // login and get users data
    dispatch(fetchUserListAction()); // cache list of users for dropdown lists purposes
    dispatch(fetchTranslations()); // re-fetch translations using redux actions - it will be used by legacy components
  }, []);

  const translations = useSelector(getTranslations);
  return (
    <AppRouter translations={translations} />
  )
}

export default App;
